import { FunctionFactory } from "survey-core";
import { calculateProteinRange } from "../features/calculations";
import { BodyFat } from "./bodyfat";
import { Goals } from "./goals";
import { WeightUnit, getWeightPounds } from "./weight";

enum ProteinTracking {
  NoIdea = "NoIdea",
  EatingMore = "EatingMore",
  EatingLess = "EatingLess",
  PrettyClose = "PrettyClose",
}

const proteinQuestion = {
  name: "protein",
  title: `For your goal, we estimate you should eat around <div class="highlight">{proteinText} grams of protein</div> a day. How close are you to this now?`,
  description: `Protein powers your gains—we’ll guide you to hit it.`,
  type: "radiogroup",
  choices: [
    {
      value: ProteinTracking.NoIdea,
      text: `I have no idea`,
    },
    {
      value: ProteinTracking.EatingMore,
      text: `Definitely eating more`,
    },
    {
      value: ProteinTracking.EatingLess,
      text: `Definitely eating less`,
    },
    {
      value: ProteinTracking.PrettyClose,
      text: `Pretty close to that target`,
    },
  ],
  isRequired: true,
};

const goalProteinTextExpression = {
  name: "goalProteinText",
  expression: "renderGoalProteinText({goals})",
};

const proteinTextExpression = {
  name: "proteinText",
  expression: "renderProteinText({weightUnit}, {weight}, {bodyFat})",
};

function renderGoalProteinText(params: any[]): string {
  const goals = params[0] as Goals;
  switch (goals) {
    case Goals.LoseFat:
      return `To build muscle and keep your metabolism high as you lose weight,`;
    case Goals.BuildMuscle:
      return `To maximize muscle growth,`;
    case Goals.BuildMuscleAndLoseFat:
      return `To maintain/build muscle as you lose fat,`;
  }
}

function renderProteinText(params: any[]): string {
  if (params === undefined || params === null) return "";
  const weightUnit = params[0] as WeightUnit;
  const weightPounds = getWeightPounds(params[1] as number, weightUnit);
  const bodyFat = params[2] as BodyFat;
  const proteinRange = calculateProteinRange(bodyFat, weightPounds);

  // Use midpoint of min and max
  return Math.round((proteinRange[0] + proteinRange[1]) / 2).toFixed(0);
}

FunctionFactory.Instance.register('renderGoalProteinText', renderGoalProteinText);
FunctionFactory.Instance.register('renderProteinText', renderProteinText);

export {
  ProteinTracking,
  goalProteinTextExpression,
  proteinQuestion,
  proteinTextExpression,
  renderProteinText,
};

